import React, { useContext, useState } from 'react';
import { RouteComponentProps, NavLink, withRouter } from 'react-router-dom';
import { Button, Icon, Row, Col } from 'antd';
import AuthContext from 'Context/AuthContext';
import ArrivalSchedule from 'components/Schedule/ArrivalSchedule';
import StrippingSchedule from 'components/Schedule/StrippingSchedule';
import { ImportantInfo } from '../HomePage.Style';


interface Props extends RouteComponentProps {
}

const BaseHomeRightSection = (props: Props) => {
  const context = useContext(AuthContext);
  const [homeMode, setHomeMode] = useState(true)

  const login = (e: React.FormEvent) => {
    e.preventDefault();
    props.history.push('/login');
  }

  const columnStyle = {
    marginLeft: '30px 30px 5px 30px',
  };

  const loginColumnStyle = {
    margin: '40px 0px 5px 30px', // margin: top right bottom left;
  };



  return <Col xs={{ span: 22, offset: 1 }} sm={{ span: 22, offset: 1 }} md={{ span: 22, offset: 1 }} lg={{ span: context.data ? 7 : 5, offset: 0 }} >
    {
      context.data != undefined ?
        <Col xs={{ span: 24 }} lg={{ span: 24, offset: 2 }} style={columnStyle}>
          <Row >
            <Col>
              <ArrivalSchedule homePageIsStarted={homeMode} />
            </Col>
          </Row>
          <Row >
            <Col style={{ marginTop: 30 }}>
              <StrippingSchedule homePageIsStarted={homeMode} />
            </Col>
          </Row>
        </Col>
        : <Col xs={{ span: 24 }} style={loginColumnStyle}>
          <Row style={{ border: "solid lightgrey 2px", borderRadius: "15px", padding: "15px 20px", marginTop: "5px" }}>
            <p>
              <Button style={{ marginRight: 10 }} type="primary" size="default" onClick={login}>Login</Button>
            </p>
            <p>Already Registered? <NavLink to="/emailconfirmation" >Confirm email</NavLink></p>
            <NavLink to="/resend-emailconfirmation">Resend email confirmation code</NavLink>

            <div style={{ textAlignLast: "left", fontSize: "1em", color: "rgb(20,37,71)", marginTop: 50 }}>
              <p>
                <div ><Icon {...ImportantInfo} type="info-circle" /> Important:</div>
                Registered Mobile App Users are to login using their existing  username and password; you will be unable to reuse the same personal data to sign up here.
              </p>
            </div>
          </Row>
        </Col>
    }
  </Col>;
}

const HomeRightSection = withRouter(BaseHomeRightSection);

export default HomeRightSection;